import { device } from 'constants/media-query'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const StyledLobbyContainer = styled.section`
  display: flex;
  flex-direction: column;
  padding: 3px 0px 49px 0px;
  @media ${device.desktop} {
    padding: 84px 0 91px;
    justify-content: center;
    align-items: center;
  }
`
export const StyledTabContentTitle = styled.h1`
  display: flex;
  font-weight: 500;
  font-size: 20px;
  margin-top: 0px;
  margin-bottom: 25px;
  @media ${device.desktop} {
    display: none;
  }
`
export const StyledLinkContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  @media ${device.desktop} {
    flex-direction: row;
    gap: 36px;
    justify-content: center;
  }
`

export const StyledLink = styled(Link)`
  display: inline-block;
  color: white;
  text-decoration: none;
  width: 185px;
  aspect-ratio: 1/1;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;

  @media ${device.desktop} {
    width: 185px;
    height: 185px;
  }
`

export const StyledLinkImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
